import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: false
})
export class TextInputComponent {
  @Input() dataTestId: string;
  @Input() errorMessage: string;
  @Input() formControlRef: FormControl;
  @Input() isFullWidth = false;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() tooltipText: string;

  @Input() autocomplete?: string = null;
  @Input() inputmode?: string = null;
  @Input() mask?: string = null;
  @Input() maxLength?: number = null;
}
